var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductFocusedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 3.33301H15.0002C15.4422 3.33301 15.8661 3.5086 16.1787 3.82116C16.4912 4.13372 16.6668 4.55765 16.6668 4.99967V16.6663C16.6668 17.1084 16.4912 17.5323 16.1787 17.8449C15.8661 18.1574 15.4422 18.333 15.0002 18.333H5.00016C4.55814 18.333 4.13421 18.1574 3.82165 17.8449C3.50909 17.5323 3.3335 17.1084 3.3335 16.6663V4.99967C3.3335 4.55765 3.50909 4.13372 3.82165 3.82116C4.13421 3.5086 4.55814 3.33301 5.00016 3.33301H6.66683",
    stroke: "#7AC159",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 1.66699H7.49984C7.0396 1.66699 6.6665 2.04009 6.6665 2.50033V4.16699C6.6665 4.62723 7.0396 5.00033 7.49984 5.00033H12.4998C12.9601 5.00033 13.3332 4.62723 13.3332 4.16699V2.50033C13.3332 2.04009 12.9601 1.66699 12.4998 1.66699Z",
    stroke: "#7AC159",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductFocusedIcon);
export default __webpack_public_path__ + "static/media/productFocusedIcon.6d912461bdf9236a39c4b2fbac0fd9bb.svg";
export { ForwardRef as ReactComponent };